import { Slider as SliderUI, SliderProps as SliderUiProps } from '@mantine/core';
import { forwardRef } from 'react';

export type SliderProps = SliderUiProps;

export const Slider = forwardRef<HTMLDivElement, SliderProps>((_props, ref) => {
  // function onMouseDown() {
  //   invokeEvent('UnityActive', { isActive: false });
  // }

  // useEffect(() => {
  //   function onMouseUp() {
  //     invokeEvent('UnityActive', { isActive: true });
  //   }

  //   document.addEventListener('mouseup', onMouseUp);
  //   return () => {
  //     document.removeEventListener('mouseup', onMouseUp);
  //   };
  // });

  return <SliderUI ref={ref} {..._props} />;
});

Slider.displayName = 'Slider';

export default Slider;
